<script>
import { GlIcon, GlLink, GlTooltipDirective } from '@gitlab/ui';

export default {
  components: {
    GlIcon,
    GlLink,
  },
  directives: {
    GlTooltip: GlTooltipDirective,
  },
  props: {
    vulnerability: {
      type: Object,
      required: true,
    },
  },
};
</script>
<template>
  <gl-link
    v-gl-tooltip="s__('Vulnerability|Comments')"
    :href="vulnerability.vulnerabilityPath"
    :data-testid="`vulnerability-comments-${vulnerability.id}`"
    class="gl-display-inline-flex gl-align-items-center gl-ml-3 gl-flex-shrink-0 gl-text-body"
  >
    <gl-icon name="comment" />
  </gl-link>
</template>
